// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__2CTSS","link":"Breadcrumbs_link__3dIx8"};